/**
 * Injects a skin's token stylesheet once per document (lazy: only skins in
 * use ever reach the page). Stylesheets stay after a switch; their
 * selectors key on `data-skin`, so an unused one matches nothing.
 */
import { skinTokensCss, type SkinId, type SkinTokens } from '@velora/tokens';

const ATTR = 'data-skin-tokens';

export function ensureSkinStylesheet(
  id: SkinId,
  tokens: SkinTokens,
  doc: Document = document,
): HTMLStyleElement | null {
  const css = skinTokensCss(id, tokens);
  // An empty token set adds nothing.
  if (!css.includes('{')) return null;
  const existing = doc.head.querySelector<HTMLStyleElement>(`style[${ATTR}='${id}']`);
  if (existing) {
    if (existing.textContent !== css) existing.textContent = css;
    return existing;
  }
  const el = doc.createElement('style');
  el.setAttribute(ATTR, id);
  el.textContent = css;
  doc.head.appendChild(el);
  return el;
}
